import PolicyPage from "./PolicyPage";
import { BRAND } from "@/branding.config";

export default function AcceptableUse() {
  return (
    <PolicyPage title="Acceptable Use Policy" description={`What is and isn't allowed on ${BRAND.app_name}.`}>
      <p>By using {BRAND.app_name} you agree not to use the service for any activity described below.
      Violations may result in immediate suspension without refund.</p>
      <h2>Prohibited content</h2>
      <ul>
        <li>Malware distribution, command-and-control infrastructure or exploit hosting</li>
        <li>Content that infringes intellectual property or violates court orders</li>
        <li>Sexually explicit material involving minors — reported to law enforcement immediately</li>
        <li>Content promoting terrorism, targeted harassment or unlawful discrimination</li>
      </ul>
      <h2>Prohibited activities</h2>
      <ul>
        <li>Unsolicited email (spam) — bulk mailing lists must be opted-in and verified</li>
        <li>Denial-of-service, network scanning, brute-force attacks or credential stuffing</li>
        <li>Cryptocurrency mining on shared plans (allowed on dedicated hardware only)</li>
        <li>Any activity that degrades network stability for other {BRAND.app_name} customers</li>
      </ul>
      <h2>Reporting abuse</h2>
      <p>Report suspected violations to <a className="text-primary hover:underline" href={`mailto:${BRAND.support_email}?subject=Abuse%20report`}>{BRAND.support_email}</a>.
      We respond to actionable reports within 24 hours.</p>
      <h2>Enforcement</h2>
      <p>We may suspend or terminate service without notice for violations that endanger the
      platform or other customers. In less severe cases we issue a written notice and give
      you 48 hours to remediate.</p>
    </PolicyPage>
  );
}
